module.exports = {
  CopyMonthSetting: 'Cài đặt CopyMonth',
  FinanceSetting: 'Cài đặt dữ liệu tài chính',
  HrSetting: 'Cài đặt dữ liệu nhân sự',
  MonthlyDataArchive: 'Lưu trữ dữ liệu hàng tháng',
  MonthlyFinance: 'Ngày cố định hàng tháng (tài chính)',
  MonthlyHr: 'Ngày cố định hàng tháng (nhân sự)',
  MonthDataArchive: 'Lưu trữ dữ liệu giữa tháng',
  WeeklyDay: 'Mỗi tuần',
  SetJudgmentCriteria: 'Thiết lập điều kiện đánh giá chênh lệch',
  ExportingData: 'Đang xuất dữ liệu...',
  ExportActualAmountData: 'Xuất dữ liệu thanh toán Accpac',
  ExportInvoiceData: 'Xuất dữ liệu hóa đơn Accpac',
  ExportBillingData: 'Xuất dữ liệu hóa đơn nước ngoài Accpac',
  SelectDataWithInvoiceNumber: 'Vui lòng chọn dữ liệu có số hóa đơn.',
  SelectDataWithBillingNumber: 'Vui lòng chọn dữ liệu có số hóa đơn.'
}
